import {StripeImageDefaultBox} from './stripe-image.default.box';

export const StripeImageBox = StripeImageDefaultBox;